import { create } from 'zustand';

type ReportIssueModalState = {
  readonly isOpen: boolean;
  readonly openReportIssueModal: () => void;
  readonly closeReportIssueModal: () => void;
};

export const useReportIssueModal = create<ReportIssueModalState>((set) => ({
  isOpen: false,
  openReportIssueModal: () => {
    set({ isOpen: true });
  },
  closeReportIssueModal: () => {
    set({ isOpen: false });
  },
}));
